import { render, staticRenderFns } from "./DashboardActivities.vue?vue&type=template&id=1db7a2da&scoped=true&"
import script from "./DashboardActivities.vue?vue&type=script&lang=js&"
export * from "./DashboardActivities.vue?vue&type=script&lang=js&"
import style0 from "./DashboardActivities.vue?vue&type=style&index=0&id=1db7a2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7a2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
